<div class="d-flex align-items-center" style="margin: -5px">
  <ng-container [ngSwitch]="data">
    <p500-ui-icon
      *ngSwitchCase="'Android'"
      p500UITooltip
      [tooltipData]="'Android'"
      [name]="'android'"
      [size]="'32px'"
      [className]="'text-color--green'"
    ></p500-ui-icon>
    <p500-ui-icon
      *ngSwitchCase="'Amazon'"
      p500UITooltip
      [tooltipData]="'Amazon'"
      [name]="'amazon'"
      [size]="'30px'"
      [className]="'text-color--orange'"
    ></p500-ui-icon>
    <p500-ui-icon
      *ngSwitchCase="'Windows'"
      p500UITooltip
      [tooltipData]="'Windows'"
      [name]="'windows'"
      [size]="'30px'"
      [className]="'text-color--dark-cyan-2'"
    ></p500-ui-icon>
    <p500-ui-icon
      *ngSwitchCase="'IOS'"
      p500UITooltip
      [tooltipData]="'iOS'"
      [name]="'ios'"
      [size]="'36px'"
      [className]="'text-color--gray'"
      style="margin-top: -7px"
    ></p500-ui-icon>
    <p500-ui-icon
      *ngSwitchCase="'Macos'"
      p500UITooltip
      [tooltipData]="'Mac OS'"
      [name]="'mac-os'"
      [size]="'36px'"
      [className]="'text-color--gray'"
      style="margin-top: -7px"
    ></p500-ui-icon>
    <p500-ui-icon
      *ngSwitchDefault
      p500UITooltip
      i18n-tooltipData="@@common.other"
      tooltipData="Other"
      [name]="'list-plus'"
      [size]="'30px'"
      [className]="'text-color--purple'"
    ></p500-ui-icon>
  </ng-container>
</div>
